<template>
  <div class="main_box">
    <div class="main_body">
      <div class="guide_box">
        <h2>恭喜投票创建完成！</h2>
        <h3 class="guide_box_lable">接下来：</h3>
        <el-row>
          <el-col
            :xs="{ span: 24 }"
            :sm="{ span: 24 }"
            :md="{ span: 6 }"
            :lg="{ span: 6 }"
            :xl="{ span: 6 }"
            class="guide_step"
          >
            <div class="vote_nav_QRCode">
              <div class="code_pic">
                <el-image
                  :src="meetingInfo.MeetingWXCodeUrl"
                  :preview-src-list="meetingCodeList"
                  @click.stop="handleClickItem"
                >
                </el-image>
                <el-image
                  v-show="false"
                  :src="meetingInfo.MeetingCodeUrl"
                  :preview-src-list="meetingCodeList"
                >
                </el-image>
                <span v-if="meetingInfo.State === 4">
                  会议开始状态，投票人通过微信扫一扫进入会议。
                </span>
                <span v-if="meetingInfo.State !== 4"> 会议未开始。 </span>
              </div>
            </div>
            <div class="guide_step_num">1</div>
            <span class="guide_step_desc">
              请打开微信扫一扫，扫描二维码进行投票。
            </span>
          </el-col>
          <el-col
            :xs="{ span: 24 }"
            :sm="{ span: 24 }"
            :md="{ span: 4, offset: 1 }"
            :lg="{ span: 4, offset: 1 }"
            :xl="{ span: 4, offset: 1 }"
            class="guide_step"
          >
            <div class="guide_content">
              <div class="guide_content_item">
                <el-image
                  :src="
                    require('../../../assets/images/vote/vote_example_login.jpg')
                  "
                >
                </el-image>
              </div>
            </div>
            <div class="guide_step_num">2</div>
            <span class="guide_step_desc">
              评委输入“投票人员”添加的账号密码登录。
            </span>
          </el-col>
          <el-col
            :xs="{ span: 24 }"
            :sm="{ span: 24 }"
            :md="{ span: 12, offset: 1 }"
            :lg="{ span: 12, offset: 1 }"
            :xl="{ span: 12, offset: 1 }"
            class="guide_step"
          >
            <div class="guide_content">
              <div class="guide_content_item">
                <el-image
                  :src="
                    require('../../../assets/images/vote/vote_example_shortlist.jpg')
                  "
                >
                </el-image>
              </div>
              <div class="guide_content_item">
                <el-image
                  :src="
                    require('../../../assets/images/vote/vote_example_sort.jpg')
                  "
                >
                </el-image>
              </div>
              <div class="guide_content_item">
                <el-image
                  :src="
                    require('../../../assets/images/vote/vote_example_score.jpg')
                  "
                >
                </el-image>
              </div>
            </div>
            <div class="guide_step_num">3</div>
            <span class="guide_step_desc"> </span>
          </el-col>
        </el-row>
        <br />
        <el-button type="primary" size="medium" plain @click="openWatchVote()"
          >投票监控</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      meetingInfo: {},
      meetingCodeList: []
    }
  },
  methods: {
    getMeetingVoteInfo: function () {
      this.$api.meetingManage.getMeetingVoteInfo({
        meetingID: this.$route.params.mid
      })
        .then(data => {
          this.meetingInfo = data
          this.meetingCodeList = []
          this.meetingCodeList.push(this.meetingInfo.MeetingWXCodeUrl)
          this.meetingCodeList.push(this.meetingInfo.MeetingCodeUrl)
          this.openLoading().close()
        }).catch(err => {
          this.openLoading().close()
          return err
        })
    },
    openWatchVote: function () {
      this.$router.push({ name: 'watchVote', params: { mid: this.$route.params.mid, vid: this.$route.params.vid, votetype: this.$route.params.votetype } })
    }
  },
  mounted () {
  },
  created () {
    this.getMeetingVoteInfo()
  }
}
</script>
<style lang="less">
.guide_box {
  padding: 0px 20px;
  display: -webkit-flex;
  display: flex;
  flex-wrap: nowrap;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.guide_box_lable {
  align-self: flex-start;
}
.guide_content {
  display: -webkit-flex;
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  border: 1px solid #ddd;
  border-radius: 6px;
}
.guide_content_item {
}
.guide_content_item .el-image {
  cursor: pointer;
}
.guide_step {
  display: -webkit-flex;
  display: flex;
  flex-wrap: nowrap;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
}
.guide_step_desc {
  text-align: center;
}
.guide_step_num {
  margin: 10px 0px;
  border: 5px solid #ddd;
  border-radius: 38px;
  width: 38px;
  height: 38px;
  font-size: 28px;
  text-align: center;
  line-height: 38px;
  font-weight: 900;
}
</style>
